import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LearningObjective } from './../model/model';
// Avoid name not found warnings
@Injectable()
export class LearningObjectiveService {
    public queryEndPoint = 'query-api/LearningObjective';

    constructor(private http: HttpClient) { }
    
    getAll = () => this.http.get<LearningObjective[]>(this.queryEndPoint);
    byCode = (code: string) => this.http.get<LearningObjective>(`${this.queryEndPoint}/bycode/${code}`);
    getInstruction = (id: string) => this.http.get(`${this.queryEndPoint}/${id}/LaatEensZienClipUrl`, { responseType: 'text' });
}
